import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateLoader, MissingTranslationHandler, MissingTranslationHandlerParams, TranslateStore } from '@ngx-translate/core';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { loadMessages } from 'devextreme/localization';
import * as nlMessages from 'devextreme/localization/messages/nl.json';
import * as deMessages from 'devextreme/localization/messages/de.json';
import { StaticTranslationLoader } from '../../static-translations-loader';
import Module from 'module';

loadMessages(nlMessages);
loadMessages(deMessages);


// export function createTranslateLoader(http: HttpClient) {
//     return new TranslateHttpLoader(http, './assets/i18n/', '.json');
// }

// export class MyMissingTranslationHandler implements MissingTranslationHandler {
//     handle(params: MissingTranslationHandlerParams) {
//         console.log(params);
//         return params.translateService.instant('ALGEMEEN.GEEN_VERTALING', { tag: params.key });
//     }
// }

@NgModule({
    declarations: [],
    imports: [CommonModule, TranslateModule
        // TranslateModule.forChild({
        //     loader: {
        //         provide: TranslateLoader,
        //         //useFactory: (createTranslateLoader),
        //         //deps: [HttpClient],
        //         useClass: StaticTranslationLoader
        //     },
        //     missingTranslationHandler: { provide: MissingTranslationHandler, useClass: MyMissingTranslationHandler },
        //     isolate: false,
        //     defaultLanguage: "nl",
        // })
    ],
    exports: [TranslateModule],
    providers: [TranslateStore]
})

export class LocalizationModule {
    // static forRoot(): ModuleWithProviders<LocalizationModule> {
    //     return {
    //         ngModule: LocalizationModule,
    //         providers: []
    //     }
    // }
}
